export default async function getMenuData() {
  return [
    // {
    //   title: 'Home',
    //   key: 'home',
    //   icon: 'fe fe-home',
    //   url: '/home',
    // },
    {
      title: 'Campaigns',
      key: 'campaigns',
      icon: 'fa fa-bullhorn',
      url: '/campaigns',
    },
    {
      title: 'Members',
      key: 'members',
      icon: 'fe fe-user',
      url: '/members',
    },
    {
      title: 'Winners',
      key: 'winners',
      icon: 'fa fa-trophy',
      url: '/winners',
    },
  ];
}
